<eui-card euiAccent
          [euiCollapsible]="true"
          [euiCollapsed]="true"
          *ngFor="let pdf of pdfDocumentList">
    <eui-card-header>
        <eui-card-header-title>{{ pdf.title }}</eui-card-header-title>
    </eui-card-header>
    <eui-card-content>
        <object
            width="100%"
            height="750px"
            [data]="pdf.url | safe" type="application/pdf"> Issue to display
        </object>
    </eui-card-content>
</eui-card>
